var React = require('react');

function Send (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z","key":0}),React.createElement("path",{"d":"m21.854 2.147-10.94 10.939","key":1})]);
}

Send.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-send-icon lucide-send"};

module.exports = Send;

Send.default = Send;
